import { render, staticRenderFns } from "./toReceive.vue?vue&type=template&id=c62f4638&scoped=true"
import script from "./toReceive.vue?vue&type=script&lang=js"
export * from "./toReceive.vue?vue&type=script&lang=js"
import style0 from "./toReceive.vue?vue&type=style&index=0&id=c62f4638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62f4638",
  null
  
)

export default component.exports